import { render, staticRenderFns } from "./ModuleMenuFormModal.vue?vue&type=template&id=47a15174&scoped=true"
import script from "./ModuleMenuFormModal.vue?vue&type=script&lang=js"
export * from "./ModuleMenuFormModal.vue?vue&type=script&lang=js"
import style0 from "./ModuleMenuFormModal.vue?vue&type=style&index=0&id=47a15174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a15174",
  null
  
)

export default component.exports